import { OwnerSquad } from '@/analytics/generated/segment'
import useSplitExperiment, {
  SplitExperimentVariant,
  SPLIT_EXPERIMENT_VARIANTS,
} from '@/hooks/useSplitExperiment'

export const FINANCIAL_REPORT_TITLE_EXPERIMENT_NAME =
  'seller_financial_report_title_ab'
export const FINANCIAL_REPORT_TITLE_EXPERIMENT_OWNER = OwnerSquad.DtcZeSetup
export const FINANCIAL_REPORT_TITLE_EXPERIMENT_VARIANT_TITLE =
  'Valores recebidos'

export const getFinancialReportExperimentTitle = (
  controlTitle: string,
  variantName: SplitExperimentVariant
) => {
  return variantName === SPLIT_EXPERIMENT_VARIANTS.VARIANT
    ? FINANCIAL_REPORT_TITLE_EXPERIMENT_VARIANT_TITLE
    : controlTitle
}

const useFinancialReportTitleExperiment = () => {
  const experiment = useSplitExperiment({
    splitName: FINANCIAL_REPORT_TITLE_EXPERIMENT_NAME,
  })

  return {
    ...experiment,
    getTitle: (controlTitle: string) =>
      getFinancialReportExperimentTitle(controlTitle, experiment.variantName),
  }
}

export default useFinancialReportTitleExperiment
